import {Component, OnInit} from '@angular/core';

import {Inscricao} from "../inscricao/inscricao";
import {InscricaoService} from "../inscricao/inscricao.service";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {ActivatedRoute, Router} from "@angular/router";
import {EventosService} from "../eventos/eventos.service";
import {forEach} from "@angular/router/src/utils/collection";
import {Evento} from "../eventos/evento";
import {Trabalho} from "../trabalho/trabalho";
import {AppComponent} from "../app.component";
import {AcessoService} from "../acesso/acesso.service";
import {Declaration} from "@angular/compiler/src/i18n/serializers/xml_helper";
declare var jQuery: any;

@Component({
    selector: 'app-inscricao-list',
    templateUrl: './inscricao-list.component.html',
    styleUrls: ['./inscricao-list.component.css'],
    providers: [TrabalhoService,
        InscricaoService,
        EventosService,
        AcessoService
    ]

})
export class InscricaoListComponent extends AppComponent implements OnInit {

    inscricoes: Inscricao[];
    eventos: Evento[];
	trabalhos: Trabalho[];
    aplicacao: AppComponent;
    perfil:any;
    insc_d = new Object();
    carregado =0;

	getTrabalhos() {
		 let user_id = +this.acessoService.getUsuario().id;
		 this.trabalhoService.getTrabalhosPorUsuario()
            .then(dados => this.setTrabs(dados));
	}
	
    getinscricoes() {
        let user_id = +this.acessoService.getUsuario().id;
        this.inscricaoService.getInscricoes(user_id)
            .then(inscricao => this.setinsc(inscricao));
    }

    getEventos() {
        this.eventoService.get().then(evento => this.setEvent(evento));
    }

    setinsc(dados){
        this.inscricoes=dados;
        this.carregado=this.carregado+1;
    }
	
    setEvent(dados){
        this.eventos=dados;
        this.carregado=this.carregado+1;
    }
	
	setTrabs(dados: any) {
		this.trabalhos=dados;
		this.carregado=this.carregado + 1;
	}

    delete(id){
        let delInsc = confirm("Você deseja apagar esta inscrição?");
        if(delInsc){
            this.insc_d['id']=id;
            this.inscricaoService.delInsc(this.insc_d).then(
                () => this.del_line(id)
            );
        }
    }
    del_line(id){
        jQuery('#insc_'+id).remove();

    }


    ngOnInit() {
        if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			this.insc_d['user'] = this.acessoService.getUsuario().api_token;
			this.getEventos();
			this.getinscricoes();
			this.getTrabalhos();
			this.perfil=[0 , {"nome":"Participante"},{'nome':'Co-Organizador'},{'nome':'Responsável'}];
		}
	}
	
	getNomeEvento(idEvento: number): string {
		let eventos = this.eventos;
		let i = eventos.length;
		
		while (--i >= 0)
			if (eventos[i].id == idEvento)
				return eventos[i].nome;
		return "Evento Padrão";
	}
	
	evento_aberto(idEvento: number): boolean {
		let eventos = this.eventos;
		let i = eventos.length;
		let data: Date = new Date();
		
		while (--i >= 0)
			if (eventos[i].id == idEvento && data > new Date(eventos[i].datalimit))
				return false;
		return true;	
	}
	
	
	tem_proposta(inscricao: Inscricao): boolean {
		let trabalhos: Trabalho[] = this.trabalhos;
		let i: number = (trabalhos? trabalhos.length : 0);
		
		while (--i >= 0)
			if (trabalhos[i].inscricao_id == inscricao.id)
				return true;
		
		return false;
	}

}



// WEBPACK FOOTER //
// ./src/app/inscricao-list/inscricao-list.component.ts